import { useRef } from "react";

/**
 * Holds the last defined (non-`undefined`) value across renders.
 *
 * When `value` is `undefined`, the hook returns the most recent non-`undefined`
 * value it has seen. When `value` is defined, the hook updates its internal
 * reference and returns the new value.
 *
 * Returns `undefined` only if no defined value has ever been provided.
 */
export function useLastDefined<T>(value: T | undefined): T | undefined {
	const ref = useRef(value);
	if (value !== undefined) {
		ref.current = value;
	}
	return ref.current;
}
